export const products = [
  {
    id: 2,
    name: "Yam Tubers",
    price: "₦1,200",
    unit: "per tuber",
    rating: 4,
    category: "farm-produce",
    image:
      "https://images.unsplash.com/photo-1730815048561-45df6f7f331d?q=80&w=1031&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    other_images: [
      "https://images.unsplash.com/photo-1617130094141-532436117aa1?q=80&w=580&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    ],
    description: "Freshly harvested yam tubers grown locally.",
  },
  {
    id: 9,
    name: "Farm Spice Mix",
    price: "₦1,200",
    unit: "per pack",
    rating: 2,
    category: "value-added",
    image:
      "https://images.unsplash.com/photo-1532336414038-cf19250c5757?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1506368249639-73a05d6f6488?auto=format&fit=crop&q=80&w=800",
      "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=800",
    ],
    description: "Blended spices made from farm produce.",
  },
  {
    id: 3,
    name: "Smoked Catfish",
    price: "₦3,500",
    unit: "per pack",
    rating: 4,
    category: "value-added",
    image:
      "https://images.unsplash.com/photo-1599084993091-1cb5c0721cc6?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&q=80&w=800",
      "https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?auto=format&fit=crop&q=80&w=800",
    ],
    description: "Traditionally smoked catfish.",
  },
  {
    id: 4,
    name: "Tomatoes",
    price: "₦850",
    unit: "per kg",
    rating: 4,
    category: "farm-produce",
    image:
      "https://images.unsplash.com/photo-1592924357228-91a4daadcfea?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1582284540020-8acbe03f4924?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dG9tYXRvZXN8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1467020323552-36f7bf0e30e6?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fHRvbWF0b2VzfGVufDB8fDB8fHww",
    ],
    description: "Juicy tomatoes for cooking and sauces.",
  },
  {
    id: 5,
    name: "Natural Honey",
    price: "₦3000",
    unit: "per liter",
    rating: 4,
    category: "value-added",
    image:
      "https://images.unsplash.com/photo-1587049352851-8d4e89133924?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aG9uZXl8ZW58MHx8MHx8fDA%3D",
    other_images: [
      "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGhvbmV5fGVufDB8fDB8fHww",
    ],
    description: "Pure honey harvested from local beehives.",
  },
  {
    id: 6,
    name: "Cassava",
    price: "₦500",
    unit: "per kg",
    rating: 4,
    category: "farm-produce",
    image:
      "https://plus.unsplash.com/premium_photo-1725467479101-556af13a7220?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Y2Fzc2F2YXxlbnwwfHwwfHx8MA%3D%3D",
    other_images: [
      "https://images.unsplash.com/photo-1757283961570-682154747d9c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGNhc3NhdmF8ZW58MHx8MHx8fDA%3D",
    ],
    description: "High quality cassava suitable for processing.",
  },
  {
    id: 7,
    name: "Garri",
    price: "₦600",
    unit: "per kg",
    rating: 2,
    category: "value-added",
    image:
      "https://images.unsplash.com/photo-1592518530101-c7413d0c1118?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Z2Fycml8ZW58MHx8MHx8fDA%3D",
    other_images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQQovFq6-afHSkhHV9VdfsAC8qdj1SkEHZNw&s",
    ],
    description: "Well processed crispy garri.",
  },
  {
    id: 8,
    name: "Fresh Eggs",
    price: "₦2,800",
    unit: "per crate",
    rating: 4,
    category: "farm-produce",
    image:
      "https://images.unsplash.com/photo-1516448620398-c5f44bf9f441?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1498654077810-12c21d4d6dc3?auto=format&fit=crop&q=80&w=800",
      "https://images.unsplash.com/photo-1506976785307-8732e854ad03?auto=format&fit=crop&q=80&w=800",
    ],
    description: "Farm fresh eggs collected daily.",
  },

  {
    id: 10,
    name: "Plantain",
    price: "₦1,000",
    unit: "per bunch",
    rating: 4,
    category: "farm-produce",
    image:
      "https://images.unsplash.com/photo-1552709607-08d00227833d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGxhbnRhaW58ZW58MHx8MHx8fDA%3D",
    other_images: [
      "https://media.istockphoto.com/id/1169934541/photo/plantain-banana-i.webp?a=1&b=1&s=612x612&w=0&k=20&c=9pqJdLWgNFK4NgXLpDGiR3DiKv1A6kQDWb8XcGOtc6o=",
    ],
    description: "Naturally ripened plantain.",
  },
  {
    id: 11,
    name: "Groundnut Oil",
    price: "₦2,200",
    unit: "per liter",
    rating: 2,
    category: "value-added",
    image:
      "https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1757801333068-d52a3e448cde?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Z3JvdW5kbnV0JTIwb2lsfGVufDB8fDB8fHww",
    ],
    description: "Naturally extracted groundnut oil.",
  },
  {
    id: 12,
    name: "Maize",
    price: "₦650",
    unit: "per kg",
    rating: 4,
    category: "farm-produce",
    image:
      "https://plus.unsplash.com/premium_photo-1705338026411-00639520a438?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8cmljZXxlbnwwfHwwfHx8MA%3D%3D",
    other_images: [
      "https://images.unsplash.com/photo-1536679545707-c76a741d7a50?auto=format&fit=crop&q=80&w=800",
    ],
    description: "Dried maize grains for food and feed.",
  },
  {
    id: 13,
    name: "Yam Flour",
    price: "₦1,400",
    unit: "per kg",
    rating: 1,
    category: "value-added",
    image:
      "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1550507992-eb63ffee0847?auto=format&fit=crop&q=80&w=800",
    ],
    description: "Smooth yam flour, hygienically processed.",
  },
  {
    id: 14,
    name: "Okra",
    price: "₦700",
    unit: "per kg",
    rating: 4,
    category: "farm-produce",
    image:
      "https://images.unsplash.com/photo-1414450397866-85f90db48714?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1627916607164-7b20241db935?auto=format&fit=crop&q=80&w=800",
    ],
    description: "Tender okra pods for soups.",
  },
  {
    id: 15,
    name: "Animal Feed",
    price: "₦5,000",
    unit: "per bag",
    rating: 4,
    category: "value-added",
    image:
      "https://images.unsplash.com/photo-1531123414780-f74242c2b052?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1535451801241-b5395e1d4a1b?auto=format&fit=crop&q=80&w=800",
    ],
    description: "Nutritious feed formulated from farm by products.",
  },
  {
    id: 16,
    name: "Local Rice",
    price: "₦1,100",
    unit: "per kg",
    rating: 4,
    category: "farm-produce",
    image:
      "https://images.unsplash.com/photo-1686820740687-426a7b9b2043?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8cmljZXxlbnwwfHwwfHx8MA%3D%3D",
    other_images: [
      "https://plus.unsplash.com/premium_photo-1674654419403-1a80edb26881?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fHJpY2V8ZW58MHx8MHx8fDA%3D",
    ],
    description: "Stone free locally processed rice.",
  },
  {
    id: 17,
    name: "Cabbage",
    price: "₦1,300",
    unit: "per kg",
    rating: 5,
    category: "value-added",
    image:
      "https://images.unsplash.com/photo-1594282486552-05b4d80fbb9f?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1594282486552-05b4d80fbb9f?auto=format&fit=crop&q=80&w=800",
      "https://images.unsplash.com/photo-1668120082831-e83f387e3461?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Y2FiYWdlfGVufDB8fDB8fHww",
    ],
    description: "Sun dried pepper with strong aroma.",
  },
  {
    id: 18,
    name: "Onions",
    price: "₦950",
    unit: "per kg",
    rating: 3,
    category: "farm-produce",
    image:
      "https://images.unsplash.com/photo-1618512496248-a07fe83aa8cb?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1508747703725-719777637510?auto=format&fit=crop&q=80&w=800",
    ],
    description: "Dry onions with long shelf life.",
  },
  {
    id: 1,
    name: "Palm Oil",
    price: "₦3,500",
    unit: "per liter",
    rating: 4,
    category: "value-added",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGbuNvNYC6aJACM6eUymdaSAcl8RKCYxgFqjpbZQwThg&s",
    other_images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGr70Xw6sGolrW3-Qw4-YJQR1OD1RYGulnJIYlvFoRig&s",
    ],
    description: "Pure red palm oil with no additives.",
  },
  {
    id: 19,
    name: "Cassava Flour",
    price: "₦900",
    unit: "per kg",
    rating: 1,
    category: "value-added",
    image:
      "https://images.unsplash.com/photo-1514733670139-4d87a1941d55?auto=format&fit=crop&q=80&w=800",
    other_images: [
      "https://images.unsplash.com/photo-1614032684758-06763a8c1407?auto=format&fit=crop&q=80&w=800",
    ],
    description: "Fine cassava flour for baking.",
  },
  {
    id: 20,
    name: "Fresh Pepper",
    price: "₦900",
    unit: "per kg",
    rating: 2,
    category: "farm-produce",
    image:
      "https://images.unsplash.com/photo-1601077698487-0047c339d313?q=80&w=1031&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    other_images: [
      "https://images.unsplash.com/photo-1763221126437-ebf2339c7b67?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGZyZXNoJTIwcGVwcGVyfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1609869882537-6a860e45a0d6?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZnJlc2glMjBwZXBwZXJ8ZW58MHx8MHx8fDA%3D",
    ],
    description: "Fresh red pepper harvested daily.",
  },
];
